(function table () {
  const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
  const compName = "table";
  const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
  const Log = logFactory(`${compName}.js`);

   if (!isCompExists(compName, Log)) {
     return;
   }

   $(() => {
     let isMobile = window.matchMedia("(max-width: 768px)");
     let reloading = false;

     const onResponsiveChange = () => {
      if (reloading) return;
      reloading = true;
      requestAnimationFrame(() => location.reload());
     };

      isMobile.addEventListener ? isMobile.addEventListener("change", onResponsiveChange)
                                : isMobile.addListener(onResponsiveChange);
     let isMounted = [false];

     const options = {
       perPage: 1,
       perMove: 1,
       easing: 'ease-out',
       classes: {
         prev: 'i-arrow-left-short',
         next: 'i-arrow-right-short'
       },
       i18n: {
         prev: "Colonne précédente",
         next: "Colonne suivante",
         slideX: "Aller à la colonne %s",
         carousel: "tableau",
         slide: "colonne",
         select: "Sélectionner une colonne à afficher",
         slideLabel: "%s sur %s"
       }
     }

    const splides = document.querySelectorAll('.splide.table.rowgroup_carousel') || [];

    const handleSplideCarouselForTables = (splide, current, index) => {
        let container = splide.parentElement.parentElement.querySelector('.sr-only_container');
        if(isMobile.matches && !isMounted[index]) {

          container.classList.toggle('hide-table');
          container.classList.toggle('sr-only')

          current.mount();
          isMounted[index] = true;
        } else if (!isMobile.matches && isMounted[index]) {

          container.classList.toggle('hide-table');
          container.classList.toggle('sr-only')

          current.destroy();
          isMounted[index] = false;
        }
    }

    splides?.length > 0 && splides.forEach((splide, index) => {
        let current = new Splide(splide, options);

        current.on('mounted', () => {
          const arrowsContainer = splide.querySelector('.splide__arrows');
          const paginationContainer = splide.querySelector('.splide__pagination');
          arrowsContainer.setAttribute('aria-hidden', 'true');
          paginationContainer.setAttribute('aria-hidden', 'true');
        })

        current.on('pagination:updated', (data) => {
          data.items.forEach((item, index) => {
            let perPage = 1;
            let start = index * perPage + 1;
            let end = Math.min(start + perPage - 1, current.length);

            item.button.ariaLabel = `Afficher les avis clients ${start} à ${end}`;
            item.button.ariaCurrent = Boolean(item.button.ariaSelected);
          });
        });

        handleSplideCarouselForTables(splide, current, index);
    })
   })

})()